<template>
  <div>
    <div class="form-list">
      <div class="form-header">일반</div>
      <el-form :model="formModel" label-width="120px" label-position="left">
        <el-form-item label="X / Y">
          <el-input-number v-model="formModel.x" :precision="0" controls-position="right" :style="smallField"></el-input-number>
          <el-input-number v-model="formModel.y" :precision="0" controls-position="right" :style="smallField"></el-input-number>
        </el-form-item>
        <el-form-item label="가로 / 세로">
          <el-input-number v-model="formModel.width" :min="1" :precision="0" controls-position="right" :style="smallField"></el-input-number>
          <el-input-number v-model="formModel.height" :min="1" :precision="0" controls-position="right" :style="smallField"></el-input-number>
        </el-form-item>
        <el-form-item label="회전">
          <el-input-number v-model="formModel.r" :precision="0" controls-position="right" :style="fullField"></el-input-number>
        </el-form-item>
      </el-form>
    </div>
    <div class="form-list">
      <div class="form-header">대상</div>
      <el-form :model="formModel" label-width="120px" label-position="left">
        <el-form-item label="내용">
          <el-input type="textarea" v-model="formModel.text" :style="fullField" resize="none" :rows="3"></el-input>
        </el-form-item>
        <el-form-item label="색상">
          <w-color-field v-model="formModel.labelColor" :style="fullField"></w-color-field>
        </el-form-item>
        <el-form-item label="크기">
          <el-input-number v-model="formModel.labelOptions.labelSize" :min="1" controls-position="right" :style="fullField"></el-input-number>
        </el-form-item>
        <el-form-item label="폰트">
          <el-select v-model="formModel.labelFont" :style="fullField">
            <el-option v-for="item in MapConst.FONT_FAMILIES" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="폰트 굵기">
          <el-checkbox v-model="formModel.labelOptions.labelBold"></el-checkbox>
        </el-form-item>
        <el-form-item label="정렬">
          <el-select v-model="formModel.labelPosition" :style="fullField">
            <el-option label="왼쪽" value="LM"></el-option>
            <el-option label="가운데" value="CM"></el-option>
            <el-option label="오른쪽" value="RM"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import WColorField from '@/components/form/ColorField';

import ObjectProperty from '@/mixins/topologymap/object-property';

export default {
  name: 'WLabelProperty',
  components: {
    WColorField,
  },
  mixins: [ObjectProperty],
  data() {
    return {};
  },
};
</script>
<style module>
</style>



// WEBPACK FOOTER //
// src/views/topologymap/components/property/LabelProperty.vue